export const HIT_INITIATIVE_LIST = 'HIT_INITIATIVE_LIST';
export const GET_INITIATIVE_LIST = 'GET_INITIATIVE_LIST';

export const HIT_INITIATIVE_DETAIL = 'HIT_INITIATIVE_DETAIL';
export const GET_INITIATIVE_DETAIL = 'GET_INITIATIVE_DETAIL';
